import * as React from 'react'
import { batch } from '@preact/signals-react'
import { AppAntSwitch } from '@components'
import { isOfficeGroup, officeGroup, offices } from '@signals'
import { Grid } from '@mui/material'


export default function AppCommonFiltersOfficeGroupToggleButton({ ...props }) {
    return <Grid item>
        <AppAntSwitch
            trueText="Office Group"
            checked={isOfficeGroup.value}
            onChange={e => batch(() => {
                isOfficeGroup.value = e.target.checked
                if (!e.target.checked) {
                    officeGroup.value = null
                }else{
                    offices.value = []
                }
            })}
            {...props}
        />
    </Grid>
}